import styled from 'styled-components';

export const StyledRow = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  line-height: 18px;
  margin: 3px 0px;
`;

export const StyledLabel = styled.span`
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  margin-right: 3px;
`;

export const StyledValue = styled.span`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
`;
